import React from 'react';
import { Link } from 'react-router-dom';

const BG = '#080808';
const BR = '#1c1c1c';
const A  = '#4edea3';
const AB = '#3bc48e';
const T1 = '#f0f0f0';
const T2 = '#b0b0b0';
const T3 = '#888888';

const Logo: React.FC<{ size?: number }> = ({ size = 26 }) => (
  <svg width={size} height={size} viewBox="0 0 120 120">
    <defs>
      <mask id="lm-ph">
        <rect width="120" height="120" fill="white"/>
        <path d="M60 30 A32 32 0 0 1 60 90 A32 32 0 0 1 60 30 Z" fill="black"/>
      </mask>
    </defs>
    <g mask="url(#lm-ph)">
      <circle cx="44" cy="60" r="32" fill="#ffffff"/>
      <circle cx="76" cy="60" r="32" fill="#ffffff"/>
    </g>
  </svg>
);

const NAV_LINKS = [
  { label: 'Features', href: '/#features' },
  { label: 'About',    href: '/#about' },
  { label: 'Pricing',  href: '/#pricing' },
  { label: 'Sources',  href: '/sources' },
  { label: 'Creators', href: '/creators' },
  { label: 'Blog',     href: '/blog' },
];

const PublicHeader: React.FC = () => (
  <header style={{
    position: 'sticky', top: 0, zIndex: 100,
    borderBottom: `1px solid ${BR}`,
    background: 'rgba(8,8,8,0.85)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
  }}>
    <div className="pub-header-inner" style={{
      width: '100%', padding: '0 28px', height: 60, boxSizing: 'border-box',
      display: 'grid', gridTemplateColumns: '1fr auto 1fr', alignItems: 'center',
    }}>
      {/* Logo — left */}
      <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
        <Logo size={26} />
        <span style={{
          fontFamily: "'Space Grotesk',sans-serif", fontSize: 17,
          fontWeight: 800, color: '#ffffff', letterSpacing: '-0.02em',
        }}>
          Electa Labs
        </span>
      </Link>

      {/* Nav links — truly centered */}
      <nav className="pub-header-nav" style={{ display: 'flex', alignItems: 'center', gap: 2, justifyContent: 'center' }}>
        {NAV_LINKS.map(({ label, href }) => (
          <a key={label} href={href} style={{
            fontSize: 13, color: T3, textDecoration: 'none',
            padding: '6px 13px', borderRadius: 7, fontWeight: 500,
            transition: 'color .15s',
          }}
          onMouseEnter={e => { e.currentTarget.style.color = T1; }}
          onMouseLeave={e => { e.currentTarget.style.color = T3; }}>
            {label}
          </a>
        ))}
      </nav>

      {/* CTAs — right */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'flex-end' }}>
        <Link to="/login" style={{
          fontSize: 13, color: T2, textDecoration: 'none',
          padding: '7px 14px', borderRadius: 7, fontWeight: 500,
          transition: 'color .15s',
        }}
        onMouseEnter={e => { e.currentTarget.style.color = T1; }}
        onMouseLeave={e => { e.currentTarget.style.color = T2; }}>
          Sign in
        </Link>
        <Link to="/register" style={{
          fontSize: 13, fontWeight: 700, color: '#000',
          background: A, textDecoration: 'none',
          padding: '8px 18px', borderRadius: 8,
          transition: 'background .15s', whiteSpace: 'nowrap',
        }}
        onMouseEnter={e => { (e.currentTarget as HTMLAnchorElement).style.background = AB; }}
        onMouseLeave={e => { (e.currentTarget as HTMLAnchorElement).style.background = A; }}>
          Start free trial
        </Link>
      </div>
    </div>
  </header>
);

export default PublicHeader;
